import { ButtonConfirm } from "components/buttons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useEnrollmentViewContext } from "..";
import { DoCloseEnrollment } from "./DoCloseEnrollment";

/////////////////////////////////////////////////////////////////////////////////////

interface IEnrollmentCloseButtonProps {
    disabled?: boolean;
}

export const EnrollmentCloseButton = ({ disabled = false }: IEnrollmentCloseButtonProps) => {

    const { t } = useTranslation("lms");
    const { enrollment, onReload } = useEnrollmentViewContext();

    const [confirming, setConfirming] = useState<boolean>(false);

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    if (enrollment.finalizationDate === null && enrollment.canFinish) {

        return (
            <>
                <ButtonConfirm
                    key="confirm"
                    fullWidth
                    variant="contained"
                    title={t("Student.EnrollmentView.CompleteButtonText")}
                    text={t("Student.EnrollmentView.CompleteButtonText")}
                    onClick={() => setConfirming(true)}
                    color={enrollment.canForceFinish ? "error" : "success"}
                    disabled={disabled}
                />

                <DoCloseEnrollment
                    open={confirming}
                    onAction={
                        (status) => {
                            setConfirming(false);
                            if (status == "closed") onReload();
                        }
                    }
                />
            </>
        );
    }

    return null;
};

